export default "__VITE_ASSET__DFzg4513__"